import 'normalize.css';
import './App.css';

import { useState, useEffect, useRef, useCallback } from "react"
import { identity } from "@deso-core/identity"

import {
  createAssociationTransaction, 
  deleteAssociationTransaction,
  associationsQuery,
  getAssociationsCounts,
  getSingleProfile,
  avatarUrl
} from './utils/deso-api'

function App() {
  const isRunned = useRef(false);

  //const POST_HASH = "5b74a79d44c94386498f1af736cac802c77cf3f405ace31f244653d3ef69bbdd"    // - original legacy 330 games played
  //const POST_HASH = "ed346d58dd8ea6a4b9a21e8a05abcd391c60f5d93ae97196b8fd9b750166d7e7"    // round 2
  const POST_HASH = "1f3af909dd4c018fa700391fc7f1da9552a5d936b52dac08b1d3b391de25ed22"    // round 3 switching to "001074" format from "1074"
  //const POST_HASH = "abfed1ab2229704385b9afccd07267de26d98f66aaaf2aeb51d2ee249ae975e9"      // test user switch 
  const APP_KEY = "BC1YLfwK9BccQWhvFdxYNkoTfJqf9DYiZaoS41ZL7ySoAVbh6ooDMj8"

  const TOP = 100

  const APP_NAME = 'First DeSo Arcade Game made by @brootle. Play at https://deso-games.netlify.app' // aka MEMO for derived keys

  const [loggedUserPublicKey, setLoggedUserPublicKey] = useState(undefined);  
  const [loggedUserProfile, setLoggedUserProfile] = useState(undefined);  

  const [altLoggedUsers, setAltLoggedUsers] = useState(undefined)

  const [finalScore, setFinalScore] = useState(undefined);  

  const [topLeaders, setTopLeaders] = useState([]);  

  const [totalPlayed, setTotalPlayed] = useState(undefined);  

  const [showSwitchUserMenu, setShowSwitchUserMenu] = useState(undefined);  


  ////////////////////////////////////////////////////
  const switchUsersEl = useRef(null);

  const useOnClickOutside = (ref, handler) => {
      useEffect(
        () => {
          const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            //console.log("event.target: ", event.target)
            if (!ref.current || ref.current.contains(event.target)) {
              return;
            }       
            handler(event);
          };
          document.addEventListener("mousedown", listener);
          document.addEventListener("touchstart", listener);
          return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
          };
        },
        [ref, handler]
      );
  }    

  useOnClickOutside(switchUsersEl, () => setShowSwitchUserMenu(false));  

  const handleSwitchUserMenuToggle = () => {
    if(!showSwitchUserMenu){
      setShowSwitchUserMenu(true)
    } else {
      setShowSwitchUserMenu(false)
    }
  }
  ////////////////////////////////////////////////////  


  const makeAssociationsQuery = async () => {
    try {

      let settings = {
        AssociationType: "SCORE",
        PostHashHex: POST_HASH,
        //SortDescending: true, // If true, results are returned in reverse order
        IncludeTransactorProfile: true,
        Limit: TOP,
        SortDescending: true
      }          
      
      const result = await associationsQuery(settings)
      let {error, Associations, PublicKeyToProfileEntryResponse} = result
      //console.log("getAssociationsCount result: ", result)

      if(Associations && PublicKeyToProfileEntryResponse){
        // sort result
        Associations.sort((a, b) => Number(b.AssociationValue || 0) - Number(a.AssociationValue || 0));
        //console.log("getAssociationsCount result SORTED: ", Associations);    
        let leaderboard = Associations.slice(0, TOP);     
        //console.log("leaderboard: ", leaderboard)

        let leaderboardData = []
        leaderboard.forEach(data => {
          leaderboardData.push({
            profile: PublicKeyToProfileEntryResponse[data?.TransactorPublicKeyBase58Check],
            publicKey: data?.TransactorPublicKeyBase58Check,
            score: data?.AssociationValue,
            id: data?.AssociationID
          })
        });

        //console.log("leaderboardData: ", leaderboardData)
        setTopLeaders(leaderboardData)
      }


      if(error){
          console.log("error: ", error)
      }



    } catch (error) {
      console.log("Error: ", error)
    }    
  } 
  
  const countAssociations = async () => {
    try {

      let settings = {
        AssociationType: "SCORE",
        PostHashHex: POST_HASH,
      }          
      
      const result = await getAssociationsCounts(settings)

      let {error, Total} = result
      console.log("getAssociationsCounts result: ", result)

      if(Total){
        setTotalPlayed(Total)
      }


      if(error){
          console.log("error: ", error)
      }



    } catch (error) {
      console.log("Error: ", error)
    }    
  }   

  const updateLoggedUserProfile = async (publicKey) => {

    setFinalScore(undefined)

    if(!publicKey){
      setLoggedUserProfile(undefined)
      return;
    }

    try {

      let settings = {
          PublicKeyBase58Check: publicKey
      }    
          
      const result = await getSingleProfile(settings)    
      let { Profile, error } = result

      if(error){
          console.log("error: ", error)
          setLoggedUserProfile(undefined)
      }  

      if(Profile){
        console.log("Loaded Profile: ", Profile)
        setLoggedUserProfile(Profile)
      }

    } catch (error) {
      console.log("Error: ", error)
    }   
  }

  const makeAssociation = useCallback(async(score, user) => {
    try {

      let settings = {
          //TransactorPublicKeyBase58Check: loggedUserPublicKey,
          TransactorPublicKeyBase58Check: user,
          PostHashHex: POST_HASH,    // my post
          AppPublicKeyBase58Check: APP_KEY, // Gemstori
          AssociationType: "SCORE",
          // AssociationValue: finalScore.toString(),
          AssociationValue: score.toString(),
          MinFeeRateNanosPerKB: 1000
      }          
         
      
      const result = await createAssociationTransaction(settings)
      let {error, TransactionHex} = result
      console.log("createAssociationTransaction result: ", result)

      if(error){
          console.log("error: ", error)
      }

      if(TransactionHex){
        const signedTransaction = await identity.signTx(TransactionHex)
        console.log("identity.signTx result: ", signedTransaction)

        const submittedTransaction = await identity.submitTx(signedTransaction)
        console.log("identity.submitTx result: ", submittedTransaction)

        // wait a bit and fetch scores
        countAssociations() // update how many times game was played
        makeAssociationsQuery() // update leaderboard
      }

    } catch (error) {
      console.log("Error: ", error)
    }
  }, [])

  const deletePostAssociation = async (AssociationID) => {
    try {

      let settings = {
          TransactorPublicKeyBase58Check: loggedUserPublicKey,
          AssociationID: AssociationID,
          MinFeeRateNanosPerKB: 1000
      }          
         
      
      const result = await deleteAssociationTransaction(settings)
      let {error, TransactionHex} = result
      console.log("deleteAssociationTransaction result: ", result)

      if(error){
          console.log("error: ", error)
      }

      if(TransactionHex){
        const signedTransaction = await identity.signTx(TransactionHex)
        console.log("identity.signTx result: ", signedTransaction)

        const submittedTransaction = await identity.submitTx(signedTransaction)
        console.log("identity.submitTx result: ", submittedTransaction)

        // refresh leaderboard
        makeAssociationsQuery()
      }

    } catch (error) {
      console.log("Error: ", error)
    }   
  }    

  const hasAltUsers = (obj) => {
    return Object.keys(obj).length > 0;
  }  


  useEffect(() => {

    // used this solution to prevent this code from running twice on app load
    // https://stackoverflow.com/a/72953313/6261255
    if(isRunned.current) return;
    isRunned.current = true;

  
    identity.configure({
      spendingLimitOptions: {
        // NOTE: this value is in Deso nanos, so 1 Deso * 1e9
        GlobalDESOLimit: 0.1 * 1e9, // 1 Deso
        //IsUnlimited: true, // be careful, this cancels all limits and grants unlimted transactions types and number of transactions that can be signed and submitted by the app
        // https://github.com/deso-protocol/core/blob/a836e4d2e92f59f7570c7a00f82a3107ec80dd02/lib/network.go#L244
        TransactionCountLimitMap: {
          // BASIC_TRANSFER: 'UNLIMITED', // 2 basic transfer transactions are authorized
          // SUBMIT_POST: 'UNLIMITED', // 4 submit post transactions are authorized
          // UPDATE_PROFILE: 'UNLIMITED',
          // LIKE: 'UNLIMITED',
          // FOLLOW: 'UNLIMITED',
          // CREATE_POST_ASSOCIATION: 'UNLIMITED'
        },
        // need to add extra map https://github.com/deso-protocol/deso-workspace/blob/48c338918ffeb94809e64ad4be6eba9e27c90259/libs/identity/src/lib/permissions-utils.spec.ts#L140
        AssociationLimitMap: [
          {
            AssociationClass: 'Post',
            AssociationType: 'SCORE',
            //AssociationType: 'POLL_RESPONSE',
            AppScopeType: 'Scoped',
            AppPublicKeyBase58Check: APP_KEY,
            //AppPublicKeyBase58Check: "BC1YLgTKfwSeHuNWtuqQmwduJM2QZ7ZQ9C7HFuLpyXuunUN7zTEr5WL",
            //AssociationOperation: 'Create',
            AssociationOperation: 'Any',
            OpCount: 'UNLIMITED',
          },
        ],        
      },
    
      // This will be associated with all of the derived keys that your application
      // authorizes.
      appName: APP_NAME,
    })
    
    identity.subscribe((state) => {

      const {currentUser, alternateUsers, event} = state;
      console.log("state: ", state)

      // SUBSCRIBE
      // LOGIN_START
      // AUTHORIZE_DERIVED_KEY_START
      // AUTHORIZE_DERIVED_KEY_END
      // LOGIN_END
      // LOGOUT_START
      // LOGOUT_END
      switch (event) {
        case 'SUBSCRIBE':
          // there can be logged user already when app loads
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)
          break;    
        case 'LOGIN_START':
          // 
          break;      
        case 'LOGIN_END':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)             
          break;   
        case 'CHANGE_ACTIVE_USER':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)          
          break;             
        case 'AUTHORIZE_DERIVED_KEY_START':
          // 
          break;   
        case 'AUTHORIZE_DERIVED_KEY_END':
          // 
          break;                                                
        case 'LOGOUT_START':
          //     
          break;         
        case 'LOGOUT_END':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)             
          break;        
        default:
          console.log(`Event: ${event}.`);
      }      
    });    


    // https://thuannp.com/react-communication-with-iframe/
    const handler = (ev) => {
      //console.log('ev', ev)
  
      if (typeof ev.data !== 'object') return
      if (!ev.data.type) return
      if (ev.data.type !== 'game-over') return
      if (!ev.data.message) return
  
      if(ev?.data?.message?.finalScore){
        console.log("ev.data.message: ", ev.data.message)
        setFinalScore(ev.data.message.finalScore)

        // if(ev.data.message.finalScore && identity.snapshot().currentUser){
        //   makeAssociation(identity.snapshot().currentUser)
        // }
      }
    }
  
    window.addEventListener('message', handler)
  
    // Don't forget to remove addEventListener
    // return () => window.removeEventListener('message', handler)    

    // check how many times game was played 
    countAssociations()

    // update leader board on load
    makeAssociationsQuery()

    // update leaderboard every 5 seconds
    // const interval = setInterval(() => {
    //   // Call your function here
    //   makeAssociationsQuery()
    // }, 5000);

    setInterval(() => {
      // Call your function here
      countAssociations()
      makeAssociationsQuery()
    }, 10000);    

    // Return a cleanup function to clear the interval
    //return () => clearInterval(interval);

  }, [])  


  useEffect(() => {
    if(finalScore && loggedUserPublicKey){
      // makeAssociation()
      //console.log("Save Score")
      
      // only save user score if it's > of last in top10 
      //let lastLeaderScore = topLeaders[topLeaders.length - 1]?.score

      // if(finalScore > lastLeaderScore || topLeaders?.length < 10){
      //   makeAssociation(finalScore, loggedUserPublicKey)
      // }

      // convert "1074" switching to "001074"
      let scoreFromGame = finalScore
      if(finalScore > 999999){
        scoreFromGame = 999999;
      }
      const userScore = scoreFromGame.toString().padStart(6, '0');
      //const userScore = finalScore.toString().padStart(6, '0');
      makeAssociation(userScore, loggedUserPublicKey)
      //makeAssociation(finalScore, loggedUserPublicKey)
    }
    // if(finalScore){
    //   makeAssociation()
    // }    
  }, [finalScore, loggedUserPublicKey, makeAssociation])


  // leaderboard menu
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);
  const leaderboardMenuRef = useRef(null);

  useOnClickOutside(leaderboardMenuRef, () => setIsLeaderboardOpen(false));  

  const handleLeaderboardToggle = () => {
    if(!isLeaderboardOpen){
      setIsLeaderboardOpen(true)
    } else {
      setIsLeaderboardOpen(false)
    }
  }  
  //

  // const makeVoteAssociation = useCallback(async(score, user) => {
  //   try {

  //     let settings = {
  //         //TransactorPublicKeyBase58Check: loggedUserPublicKey,
  //         TransactorPublicKeyBase58Check: user,
  //         PostHashHex: "b19f00da071e78cef13151499f9c5a9258c869779784a7dcbf7755bfa5ed3dac",    // my post
  //         AppPublicKeyBase58Check: APP_KEY, // Gemstori
  //         AssociationType: "POLL_RESPONSE",
  //         // AssociationValue: finalScore.toString(),
  //         AssociationValue: score,
  //         MinFeeRateNanosPerKB: 1000
  //     }          
         
      
  //     const result = await createAssociationTransaction(settings)
  //     let {error, TransactionHex} = result
  //     console.log("createAssociationTransaction result: ", result)

  //     if(error){
  //         console.log("error: ", error)
  //     }

  //     if(TransactionHex){
  //       const signedTransaction = await identity.signTx(TransactionHex)
  //       console.log("identity.signTx result: ", signedTransaction)

  //       const submittedTransaction = await identity.submitTx(signedTransaction)
  //       console.log("identity.submitTx result: ", submittedTransaction)

  //       // // wait a bit and fetch scores
  //       // countAssociations() // update how many times game was played
  //       // makeAssociationsQuery() // update leaderboard
  //     }

  //   } catch (error) {
  //     console.log("Error: ", error)
  //   }
  // }, [])  
 
  return (
    <div className="App">

      <header className='headerContainer'>

        <div className='headerLeft'>

          { loggedUserProfile && 
            <div className='avatarContainer'>
              <a className='avatar' 
                style={  {backgroundImage: `url(${avatarUrl(loggedUserProfile)})`} }
                href={`https://www.gemstori.com/@${loggedUserProfile?.Username}`}
                target="_blank"
                rel="noreferrer"
                title={`${loggedUserProfile?.Username}`}
              >
              </a>
            </div>
          }

          {
            loggedUserPublicKey && !loggedUserProfile &&
            <div className='avatarContainer'>
              <a className='avatar' 
                style={  {backgroundImage: `url(https://node.deso.org/assets/img/default_profile_pic.png)`} }
                href={`https://www.openprosper.com/pk/${loggedUserPublicKey}`}
                target="_blank"                
                rel="noreferrer"
                title={`${loggedUserPublicKey}`}
              >
              </a>
            </div>            
          }

          <div className='manageUsersContainer'>

            <div onClick={() => identity.login()} className="manageUserButton" title='Add user' role="button">
              <svg viewBox="0 0 24 24" className='userMenuIcon'>
                <path
                  d="M3 19c.691-2.307 2.47-3 6.5-3 4.03 0 5.809.693 6.5 3"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  d="M13 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                  stroke="white"
                  strokeWidth={2}
                />
                <path
                  d="M15 6h6M18 3v6"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>              
            </div>

            {
              altLoggedUsers && hasAltUsers(altLoggedUsers) &&
                <div ref={switchUsersEl} onClick={() => handleSwitchUserMenuToggle()} className="manageUserButton" title='Switch user' role="button">
                  <svg viewBox="0 0 24 24" className='userMenuIcon'>
                    <path
                      d="M15.631 7.155a2.5 2.5 0 1 1 0 4.69M3 19c.691-2.307 2.47-3 6.5-3 4.03 0 5.809.693 6.5 3M17 15c2.403.095 3.53.638 4 2"
                      stroke="white"
                      strokeWidth={2}
                      strokeLinecap="round"
                    />
                    <path
                      d="M13 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                      stroke="white"
                      strokeWidth={2}
                    />
                  </svg>

                  {
                    showSwitchUserMenu && 
                    <div className='altUsersContainer'>                  
                      {altLoggedUsers && Object.keys(altLoggedUsers).map((key, index) => {
                        return (
                          <div key={index}>
                            <button className='altUserBtn' onClick={() => identity.setActiveUser(key)}

                              style={ 
                                {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${key}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                              }        
                            >
                              
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  }
                </div>
            }  
            
          </div>             
        </div>

        <div className='headerCenter'>
            {/* <button onClick={()=>makeVoteAssociation("No", loggedUserPublicKey)}>Vote Yes</button> */}
        </div>

        <div className='headerRight'>

          <div className='leaderboardStatsContainer'>

            <div ref={leaderboardMenuRef} onClick={() => handleLeaderboardToggle()} className="manageUserButton" title='Switch user' role="button">
              <svg className='userMenuIcon' viewBox="0 0 24 24">
                <path
                  d="M15 21H9v-8.4a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 .6.6V21ZM20.4 21H15v-2.9a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 .6.6v2.3a.6.6 0 0 1-.6.6ZM9 21v-4.9a.6.6 0 0 0-.6-.6H3.6a.6.6 0 0 0-.6.6v4.3a.6.6 0 0 0 .6.6H9ZM10.806 5.113l.909-1.927a.312.312 0 0 1 .57 0l.91 1.927 2.032.311c.261.04.365.376.176.568l-1.47 1.5.347 2.118c.044.272-.228.48-.462.351l-1.818-1-1.818 1c-.233.128-.506-.079-.462-.351l.347-2.118-1.47-1.5c-.19-.192-.085-.528.175-.568l2.034-.31Z"
                  stroke="#000"
                  strokeWidth={1.5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {
                isLeaderboardOpen && 
                <div className='leadersListContainer'>                  
                  {
                    topLeaders.length > 0 &&
                    <div className='leaderboard'>
                      <table>
                        <tbody>
                          {topLeaders.map((leader, index) => {
                            return(
                              <tr key={index} className={leader?.publicKey === loggedUserPublicKey ? 'user active' : 'user'}>
                                
                                <td>
                                  #{index+1}
                                </td>

                                <td className='playerIdentificator'>
                                  {
                                    leader?.profile?.Username 
                                    ?<a href={`https://www.gemstori.com/@${leader?.profile?.Username}`} target="_blank" title={`${leader?.profile?.Username}`} rel="noreferrer">{leader?.profile?.Username}</a>
                                    :<a href={`https://www.openprosper.com/pk/${leader?.publicKey}`} target="_blank" title={`${leader?.publicKey}`} rel="noreferrer">{leader?.publicKey}</a>
                                  }                    
                                </td>

                                <td className='playerScore'>
                                  {leader?.score}
                                </td>

                                <td>
                                  {
                                    leader?.publicKey === loggedUserPublicKey &&
                                    <div className='deleteBtnContainer'>
                                      <button onClick={() => deletePostAssociation(leader?.id)} title="Delete score">
                                        <svg viewBox="0 0 24 24">
                                          <path
                                            d="M17.23 9.78 15.01 12l2.22 2.22c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.22-2.22-2.22 2.22c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L12.89 12l-2.22-2.22a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.22 2.22 2.22-2.22c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06ZM21.32 7v10c0 .96-.78 1.75-1.75 1.75H7.64c-.61 0-1.16-.31-1.48-.82l-3.29-5.27c-.25-.4-.25-.92 0-1.33l3.29-5.26c.32-.51.88-.82 1.48-.82h11.94c.96 0 1.75.79 1.75 1.75h-.01Zm-1.5 0c0-.14-.11-.25-.25-.25H7.64c-.09 0-.17.04-.21.12L4.22 12l3.21 5.13c.05.07.13.12.21.12h11.94c.14 0 .25-.11.25-.25V7h-.01Z"
                                          />
                                        </svg>                      
                                      </button>                          
                                    </div>
                                  }                    
                                </td>
                                

                                
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>       
                    </div>     
                  }
                </div>
              }
            </div>            



          </div>

          <div className='authContainer'>
            { loggedUserPublicKey
              ?<button onClick={() => identity.logout()}>Log out</button> 
              :<button onClick={() => identity.login()}>Log in</button>
            }                      
          </div>
        </div>        
 
      </header>

      <div className='gameContainer'>

        <iframe className='game' src="./game.html" title='Game'></iframe>
     

        {/* {
          topLeaders.length > 0 &&
          <div className='leaderboard'>
            <table>
              <tbody>
                {topLeaders.map((leader, index) => {
                  return(
                    <tr key={index} className={leader?.publicKey === loggedUserPublicKey ? 'user active' : 'user'}>
                      
                      <td>
                        #{index+1}
                      </td>

                      <td className='playerIdentificator'>
                        {
                          leader?.profile?.Username 
                          ?<a href={`https://www.gemstori.com/@${leader?.profile?.Username}`} target="_blank" title={`${leader?.profile?.Username}`} rel="noreferrer">{leader?.profile?.Username}</a>
                          :<a href={`https://www.openprosper.com/pk/${leader?.publicKey}`} target="_blank" title={`${leader?.publicKey}`} rel="noreferrer">{leader?.publicKey}</a>
                        }                    
                      </td>

                      <td className='playerScore'>
                        {leader?.score}
                      </td>

                      <td>
                        {
                          leader?.publicKey === loggedUserPublicKey &&
                          <div className='deleteBtnContainer'>
                            <button onClick={() => deletePostAssociation(leader?.id)} title="Delete score">
                              <svg viewBox="0 0 24 24">
                                <path
                                  d="M17.23 9.78 15.01 12l2.22 2.22c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.22-2.22-2.22 2.22c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L12.89 12l-2.22-2.22a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.22 2.22 2.22-2.22c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06ZM21.32 7v10c0 .96-.78 1.75-1.75 1.75H7.64c-.61 0-1.16-.31-1.48-.82l-3.29-5.27c-.25-.4-.25-.92 0-1.33l3.29-5.26c.32-.51.88-.82 1.48-.82h11.94c.96 0 1.75.79 1.75 1.75h-.01Zm-1.5 0c0-.14-.11-.25-.25-.25H7.64c-.09 0-.17.04-.21.12L4.22 12l3.21 5.13c.05.07.13.12.21.12h11.94c.14 0 .25-.11.25-.25V7h-.01Z"
                                />
                              </svg>                      
                            </button>                          
                          </div>
                        }                    
                      </td>
                      

                      
                    </tr>
                  )
                })}
              </tbody>
            </table>       
          </div>     
        } */}
  
      

      </div>

      <footer className='footerContainer'>
        <div className='footerLeft'>
          <div className='madeByMessage'>
            Designed by <a href='https://www.gemstori.com/@brootle' target="_blank" rel="noreferrer">brootle</a>
          </div>
        </div>
        <div className='footerRight'>
          { totalPlayed && 
              <div className='totalPlaysContainer'>
                <div className='totalPlays'>played: {totalPlayed}</div>
              </div>
          } 
        </div>
      </footer>

    </div>
  );
}

export default App;
